var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('chartBarras',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingGrafica),expression:"loadingGrafica"}],attrs:{"chart":_vm.chart_credito}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }